export default "../css/9bb3be9cd024b8aedda8976798083900.ttf";